module.exports = __webpack_public_path__ + "static/media/slide3.9530b412.jpg";